import React from 'react';
import { Link } from 'gatsby';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { ColumnSixMd, ColumnFiveMd } from './styles/Column.styled';
import {
  BlockContent,
  LineSeparator,
  UlList,
  LiList,
  BlockInnerContent,
} from './styles/twoColumnTextBlock.styled';
import { Section } from './styles/SectionHeadline.styled';

export default function TwoColumnsTextWithBullets({ data, id, dir }) {
  const {
    leftColumnTitle,
    leftColumnParagraphs,
    rightColumnTitle,
    rightColumnParagraphs,
    bottomText,
    link,
  } = data;

  return (
    <Section id={id}>
      <Container>
        <Row>
          <ColumnSixMd>
            <BlockContent dir={dir}>
              <h3 dir={dir}>{leftColumnTitle}</h3>
              {leftColumnParagraphs.map((paragraph) => (
                <p>{paragraph}</p>
              ))}
            </BlockContent>
          </ColumnSixMd>
          <ColumnFiveMd className="offset_md_1">
            <BlockContent>
              <LineSeparator />
              <h4 dir={dir}>{rightColumnTitle}</h4>
              <UlList dir={dir}>
                {rightColumnParagraphs.map((paragraph) => {
                  if (paragraph.indexOf(': ') === -1) return <LiList>{paragraph}</LiList>;
                  return (
                    <LiList dir={dir}>
                      <strong>{paragraph.substring(0, paragraph.indexOf(': '))}</strong>
                      {paragraph.substring(paragraph.indexOf(': '))}
                    </LiList>
                  );
                })}
              </UlList>
              <BlockInnerContent>
                <p>
                  {bottomText.length > 0 ? bottomText : bottomText}&nbsp;
                  {!link ? '' : <Link href={link.url}>{link.name}</Link>}
                </p>
              </BlockInnerContent>
            </BlockContent>
          </ColumnFiveMd>
        </Row>
      </Container>
    </Section>
  );
}
